module.exports = __webpack_public_path__ + "static/media/checkbox-outline.43f8c9ba.svg";